import { Link } from 'react-router-dom';
import Button from '@/components/base/Button';

const STEPS = [
  {
    no: '01',
    icon: 'ri-search-eye-line',
    title: '发现线索',
    desc: '从公开信息与经营事件中发现候选服务机会，标注证据充分程度与业务优先级。',
  },
  {
    no: '02',
    icon: 'ri-radar-line',
    title: '验证机会',
    desc: '补充企业明细资料，核验事实与适用条件，把潜在线索推进为有依据的核心商机。',
  },
  {
    no: '03',
    icon: 'ri-flow-chart',
    title: '合规交付',
    desc: '在税务BP工作台完成方案设计、测算、复核与报告交付，形成可执行的实施路径。',
  },
  {
    no: '04',
    icon: 'ri-user-star-line',
    title: '经营决策',
    desc: '企业老板用 BOSS 经营智能体围绕收入、毛利、现金流与重大事项获得决策支持。',
  },
];

export default function ValueFlow() {
  return (
    <section className="mx-auto w-full max-w-[1440px] px-4 py-16 md:px-8 md:py-20">
      <div className="mb-10 max-w-2xl">
        <span className="text-xs font-semibold uppercase tracking-widest text-primary-700">业务闭环</span>
        <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-900 md:text-3xl">
          线索 → 商机 → 交付 → 决策
        </h2>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((s) => (
          <div
            key={s.no}
            className="relative rounded-lg border border-background-200 bg-background-50 p-6"
          >
            <span className="absolute right-5 top-5 font-heading text-3xl font-bold text-background-300">
              {s.no}
            </span>
            <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
              <i className={`${s.icon} text-xl`} />
            </span>
            <h3 className="mt-4 font-heading text-base font-semibold text-foreground-900">{s.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
          </div>
        ))}
      </div>

      <div className="band-cover-bg relative mt-16 overflow-hidden rounded-lg">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20minimal%20dark%20deep%20green%20flowing%20wave%20texture%20with%20subtle%20golden%20light%20streaks%2C%20elegant%20premium%20financial%20technology%20banner%20background%2C%20smooth%20gradient%2C%20refined%20and%20restrained%2C%20no%20text&width=1920&height=560&seq=ti-cta-band-2026&orientation=landscape"
          alt="税务洞察 TaxInsight 行动号召背景"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="band-cover-overlay absolute inset-0" />
        <div className="band-wave-layer pointer-events-none absolute inset-0" aria-hidden="true" />
        <div className="band-glow-layer pointer-events-none absolute inset-0" aria-hidden="true" />
        <div className="band-sheen-layer pointer-events-none absolute inset-0" aria-hidden="true" />
        <div className="relative z-10 flex flex-col items-start gap-6 px-6 py-12 md:flex-row md:items-center md:justify-between md:px-12 md:py-16">
          <div className="max-w-2xl">
            <h3 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
              从一个企业名称开始
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-background-100/85">
              输入企业名称即可浏览其潜在线索；登录后可以发起企业初步分析、补充资料并验证机会。
            </p>
          </div>
          <div className="flex flex-wrap gap-3">
            <Link to="/leads">
              <Button size="lg" icon="ri-radar-line" className="band-cta">
                浏览潜在线索
              </Button>
            </Link>
            <Link to="/coming-soon/orders">
              <Button size="lg" variant="outline" className="band-cta-ghost">
                查看价格与权益
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
